import React from 'react';
import styled, { css } from 'styled-components';

interface ContainerProps {
  fullWidth?: boolean;
  white?: boolean;
  isMobile?: boolean;
  marginBottom?: number;
  children: React.ReactNode;
  id?: string;
  className?: string;
}

const Container = ({
  children,
  fullWidth = false,
  white = false,
  isMobile = false,
  marginBottom = 10,
  id,
  className,
}: ContainerProps) => {
  if (React.Children.count(children) === 0) return null;
  return (
    <StyledRoot
      isMobile={isMobile}
      marginBottom={marginBottom}
      isWhite={white}
      id={id}
      className={className}
    >
      <StyledContainer
        fullWidth={fullWidth}
        isMobile={isMobile}
        isWhite={white}
      >
        {children}
      </StyledContainer>
    </StyledRoot>
  );
};

const StyledRoot = styled.div<{
  marginBottom: number;
  isMobile: boolean;
  isWhite: boolean;
}>`
  position: relative;
  margin-bottom: ${(props) => props.marginBottom}px;
  min-width: ${(props) => (props.isMobile ? 320 : 960)}px;

  ${(props) =>
    props.isWhite &&
    css`
      background-color: ${props.theme.colors.white};
    `}
`;

const StyledContainer = styled.div<{
  fullWidth: boolean;
  isMobile: boolean;
  isWhite: boolean;
}>`
  ${(props) =>
    !props.fullWidth &&
    css`
      margin: 0 auto;
      padding: 0 10px;
      box-sizing: content-box;
      min-width: 940px;
      max-width: 1240px;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      width: auto;
      min-width: auto;
      max-width: none;
    `};

  ${(props) =>
    props.isMobile &&
    !props.isWhite &&
    !props.fullWidth &&
    css`
      padding: 0 5px;
    `};
`;

export default Container;
